export enum FtmRestrictionsMessage {
  CREATE_PARTY_GROUP = 'Create party group',
  NO_PARTY_GROUP_HEADER = 'No Party Groups',
  NO_PARTY_GROUP_TOOLTIP = 'Allows you to create a group of users that are not allowed to be registered/assigned to the same activity',
  NO_PARTY_GROUP_EMPTY_STATE_TITLE = 'No groups found',
  NO_PARTY_GROUP_EMPTY_STATE_SUBTITLE = 'No party groups will be visible here once they are created',
  NO_PARTY_GROUP_EMPTY_STATE_BUTTON = 'Create new',
  REGISTRATION_LIST_HEADER = 'No Registration List',
}
